var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2918)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5241 20.15C18.7241 20.15 18.1141 19.925 17.6941 19.475C17.2741 19.015 17.0641 18.36 17.0641 17.51V16.685H18.6241V17.63C18.6241 18.31 18.9091 18.65 19.4791 18.65C20.0491 18.65 20.3341 18.31 20.3341 17.63V15.275C20.3341 14.585 20.0491 14.24 19.4791 14.24C18.9091 14.24 18.6241 14.585 18.6241 15.275V15.365H17.0641L17.3641 9.5H21.7141V11H18.8341L18.6991 13.505H18.7291C19.0391 12.995 19.5141 12.74 20.1541 12.74C20.7541 12.74 21.2091 12.945 21.5191 13.355C21.8291 13.765 21.9841 14.36 21.9841 15.14V17.51C21.9841 18.36 21.7741 19.015 21.3541 19.475C20.9341 19.925 20.3241 20.15 19.5241 20.15ZM25.545 20.15C24.735 20.15 24.115 19.92 23.685 19.46C23.255 19 23.04 18.35 23.04 17.51V12.08C23.04 10.26 23.88 9.35 25.56 9.35C26.36 9.35 26.97 9.58 27.39 10.04C27.81 10.49 28.02 11.14 28.02 11.99V12.185H26.46V11.885C26.46 11.195 26.175 10.85 25.605 10.85C25.295 10.85 25.065 10.945 24.915 11.135C24.765 11.325 24.69 11.66 24.69 12.14V14.15H24.72C25.01 13.54 25.51 13.235 26.22 13.235C26.82 13.235 27.275 13.44 27.585 13.85C27.895 14.26 28.05 14.855 28.05 15.635V17.51C28.05 18.35 27.835 19 27.405 19.46C26.975 19.92 26.355 20.15 25.545 20.15ZM25.545 18.65C26.115 18.65 26.4 18.31 26.4 17.63V15.77C26.4 15.08 26.115 14.735 25.545 14.735C24.975 14.735 24.69 15.08 24.69 15.77V17.63C24.69 18.31 24.975 18.65 25.545 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2918",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2918",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg56);
export default __webpack_public_path__ + "static/media/56.7193607d47ca6a99ba5abae890f24152.svg";
export { ForwardRef as ReactComponent };